module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8pTK7k/tc-custom/9781540260161.jpg?1735701613839",
      "alt": "This image is the cover for the book Ghostly Tales of Phoenix, Spooky America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ghostly Tales of Phoenix, Spooky America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Ghost stories from America's Valley of the Sun have never been so creepy, fun, and full of mystery! "), _c('br'), _vm._v(" Welcome to the spooky streets of Phoenix, Arizona!   Stay alert! Ghosts lurk around every corner. Even the most unexpected places might be haunted by wandering phantoms. "), _c('br'), _vm._v(" Did you know that the booming, modern metropolis of  Phoenix  is a city  filled  with ghosts? Like the spirits who haunt the Smurthwaite House, which sits on the grounds of Phoenix's oldest cemetery? Or the restless souls who linger within the walls of Phoenix's Mystery Castle, old train depots, and eerie historic mansions? Can you believe the mysterious Hohokam tribe, whose people once inhabited the Pueblo Grande Ruins and later vanished, may not have vanished after all? "), _c('br'), _vm._v(" Pulled right from history, these ghostly tales will change the way you see Phoenix forever, and have you sleeping with the lights on!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stacia Deutsch\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("New York Times  bestselling author Stacia Deutsch has written more than three hundred children's books, including  The Jessie Files , a spin-off of the beloved  Boxcar Children  mystery series. Stacia lives in Temecula, California, where she is a member of the historical society. She loves hearing spooky stories! Find her online at  www.staciadeutsch.com , @staciadeutsch_writes, and  www.facebook/staciadeutsch .")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Children’s Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0